<header class="header header-principal" role="banner">
  <div class="header-principal__inner">
    <div class="header-principal-left">
      <div class="logos">
        <div class="logo logo--0">
          <a [href]="SANTE_GOUV_URL" rel="nofollow noopener" target="_blank">
            <img
              class="ministere-logo"
              src="../../../assets/img/logo-ministere.svg"
              alt="{{'global.ministere' | translate }}"
              width="223"
              height="45"
            />
          </a>
        </div>
        <div class="logo logo--0">
          <a [href]="E_SANTE_GOUV_URL" rel="nofollow noopener" target="_blank">
            <img
              src="../../../assets/img/logo.svg"
              alt="{{'global.ans' | translate }}"
              width="223"
              height="45"
            />
          </a>
        </div>
        <p class="header__title">
          <a (click)="navigate('/home')">{{ 'header.title' | translate }}</a>
        </p>
      </div>
    </div>
    <div class="header-principal-right" *ngIf="showMenuforRoles">
      <div class="header-principal__nav">
        <div
          class="navbar navbar-expand-xl navbar-light"
          tabindex="-1"
          id="menuPrincipalTarget"
        >
          <!-- HOME BUTTON IMAGE -->
          <button
            type="button"
            class="navbar-toggler btn btn--icon-only btn-icon--header"
            data-toggle="collapse"
            data-target="#menuPrincipal"
            aria-controls="menuPrincipal"
            aria-expanded="false"
            (click)="openMenu(0)"
          >
            <svg class="svg-icon svg-menu" aria-hidden="true" focusable="false">
              <use
                xlink:href="../../../assets/svg-icons/icon-sprite.svg#menu"
              ></use>
            </svg>
            <span class="sr-only">{{ 'header.menu' | translate }}</span>
          </button>

          <!-- NAV LINKS -->
          <div
            class="collapse navbar-collapse"
            id="menuPrincipal"
            [ngClass]="{ show: idMenuOpen >= 0 }"
          >
            <button
              type="button"
              class="navbar-toggler-close d-xl-none btn btn--icon-only btn-icon--header"
              data-toggle="collapse"
              data-target="#menuPrincipal"
              aria-controls="menuPrincipal"
              aria-expanded="false"
              (click)="openMenu(-1)"
            >
              <svg
                class="svg-icon svg-close"
                aria-hidden="true"
                focusable="false"
              >
                <use
                  xlink:href="../../../assets/svg-icons/icon-sprite.svg#close"
                ></use>
              </svg>
              <span class="sr-only">{{ 'header.fermer' | translate }}</span>
            </button>

            <nav role="navigation" aria-label="Menu principal">
              <ul class="navbar-nav nav-lvl--1">
                <li
                  class="nav-item common-nav-item"
                  *ngIf="!isVisitor">
                  <a class="nav-link" (click)="navigate('/home')">
                    {{ 'header.accueil' | translate}}
                  </a>
                </li>
                <li
                  class="nav-item common-nav-item"
                   *ngIf="!isVisitor">
                  <button
                    class="nav-link"
                    type="button"
                    data-toggle="collapse"
                    data-target="#nav-collapse-submenu--3"
                    aria-controls="nav-collapse-submenu--3"
                    aria-expanded="false"
                    (click)="openMenu(1)"
                  >
                    {{ 'header.habilitations.title' | translate }}
                  </button>
                  <div
                    class="collapse nav-collapse"
                    id="nav-collapse-submenu--3"
                    data-parent="#menuPrincipal"
                    [ngClass]="{ show: idMenuOpen == 1 && showSubMenu }"
                    [style.left.px]="-55"
                  >
                    <div class="nav-collapse-inner">
                      <ul class="navbar-nav nav-lvl--2" (click)="onBlur()">
                        <!-- SUBMENU #1 -->
                        <li class="nav-item common-nav-item"
                            *ngIf="(getPermissions(permission.CL) && autorisations?.includes('CONSULTATION_CL')) ||
                               (getPermissions(permission.GARS) && autorisations?.includes('CONSULTATION_ARS')) ||
                               (getPermissions(permission.GAE) && autorisations?.includes('CONSULTATION_RPPS')) ||
                               (getPermissions(permission.MANDATAIRE) && autorisations?.includes('CONSULTATION_MANDATAIRE'))"
                        >
                          <span class="nav-title">{{'header.habilitations.gerer' | translate}}</span>
                          <ul class="navbar-nav nav-lvl--3">
                            <li *ngIf="getPermissions(permission.CL) && autorisations?.includes('CONSULTATION_CL')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/gestion/cl')">{{ 'header.habilitations.cl' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.GARS) && autorisations?.includes('CONSULTATION_ARS')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/gestion/gars')">{{ 'header.habilitations.gars' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.GAE) && autorisations?.includes('CONSULTATION_RPPS')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/gestion/gae')">{{ 'header.habilitations.gae' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.MANDATAIRE) && autorisations?.includes('CONSULTATION_MANDATAIRE')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/gestion/mandataire')">{{ 'header.habilitations.mandataire' | translate }}</a>
                            </li>
                          </ul>
                        </li>

                        <!-- SUBMENU #2 -->
                        <li class="nav-item common-nav-item"
                            *ngIf="(getPermissions(permission.CL) && autorisations?.includes('CREATION_CL')) ||
                               (getPermissions(permission.GARS) && autorisations?.includes('CREATION_ARS')) ||
                               (getPermissions(permission.GAE) && autorisations?.includes('CREATION_RPPS')) ||
                               (getPermissions(permission.MANDATAIRE) && autorisations?.includes('CREATION_MANDATAIRE'))"
                        >
                          <span class="nav-title">{{'header.habilitations.ajouter' | translate}}</span>
                          <ul class="navbar-nav nav-lvl--3">
                            <li *ngIf="getPermissions(permission.CL) && autorisations?.includes('CREATION_CL')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('habilitation/cl')">{{ 'header.habilitations.cl' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.GARS) && autorisations?.includes('CREATION_ARS')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('habilitation/gars')">{{ 'header.habilitations.gars' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.GAE) && autorisations?.includes('CREATION_RPPS')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('habilitation/gae')">{{ 'header.habilitations.gae' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.MANDATAIRE) && autorisations?.includes('CREATION_MANDATAIRE')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('habilitation/mandataire', { isCreationMandataire: true })">{{'header.habilitations.mandataire' | translate}}</a>
                            </li>
                          </ul>
                        </li>

                        <!-- SUBMENU #3 -->
                        <li
                          *ngIf="([permission.DELEGUE, permission.DELEGUE_PM, permission.CL_PM] | checkPermissions)
                                && (    autorisations?.includes('CREATION_DELEGUE')
                                    ||  autorisations?.includes('CREATION_DELEGUE_GENERIQUE')
                                    ||  autorisations?.includes('CREATION_DELEGUE_PM')
                                    ||  autorisations?.includes('CONSULTATION_DELEGUE')
                                    ||  autorisations?.includes('CONSULTATION_DELEGUE_GENERIQUE')
                                    ||  autorisations?.includes('CONSULTATION_DELEGUE_PM')
                                    ||  autorisations?.includes('CREATION_CL_PM')
                                    )"
                          class="nav-item common-nav-item"
                        >
                          <span class="nav-title">{{ 'header.habilitations.delegues' | translate }}</span>
                          <ul class="navbar-nav nav-lvl--3">
                            <li *ngIf="getPermissions(permission.DELEGUE) && autorisations?.includes('CREATION_DELEGUE')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/delegue')">{{ 'header.habilitations.ajouterDelegues' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.DELEGUE) && autorisations?.includes('CONSULTATION_DELEGUE')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/gestion/delegue')"> {{ 'header.habilitations.gererDelegues' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.DELEGUE_PM) && autorisations?.includes('CREATION_DELEGUE_PM')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/delegue-structure')">{{ 'header.habilitations.deleguerStructureTiers' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.DELEGUE_PM) && autorisations?.includes('CONSULTATION_DELEGUE_PM')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/gestion/delegue-structure')">{{ 'header.habilitations.gererStructuresDeleguees' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.CL_PM) && autorisations?.includes('CREATION_CL_PM')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/cl-structure')">{{ 'header.habilitations.designerStructureAdministrateurTechnique' | translate }}</a>
                            </li>
                            <li *ngIf="getPermissions(permission.CL_PM) && autorisations?.includes('CONSULTATION_CL_PM')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/gestion/cl-structure')">{{ 'header.habilitations.gererStructuresAdministrateursTechniques' | translate }}</a>
                            </li>
                          </ul>
                        </li>

                        <!-- SUBMENU #4 -->
                        <li
                          *ngIf="canHandleCollaborateurs
                           && (autorisations?.includes('CONSULTATION_COLLABORATEUR') || autorisations?.includes('CREATION_COLLABORATEUR'))"
                          class="nav-item common-nav-item"
                        >
                          <span class="nav-title">{{ 'header.habilitations.collaborateurs.titre' | translate }}</span>
                          <ul class="navbar-nav nav-lvl--3">
                            <li *ngIf="autorisations?.includes('CREATION_DELEGUE_GENERIQUE')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/delegue-generique')">{{ 'header.habilitations.collaborateurs.deleguesGenerique.ajouter' | translate }}</a>
                            </li>
                            <li *ngIf="autorisations?.includes('CONSULTATION_DELEGUE_GENERIQUE')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/gestion/delegue-generique')">{{ 'header.habilitations.collaborateurs.deleguesGenerique.gerer' | translate }}</a>
                            </li>
                            <li *ngIf="autorisations?.includes('CREATION_ADMIN_GENERIQUE')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/admin-generique')">{{ 'header.habilitations.collaborateurs.adminGenerique.ajouter' | translate }}</a>
                            </li>
                            <li *ngIf="autorisations?.includes('CONSULTATION_ADMIN_GENERIQUE')" class="nav-item common-nav-item">
                                <a class="nav-link" href="javascript:void(0);" (click)="navigate('/habilitation/gestion/admin-generique')">{{ 'header.habilitations.collaborateurs.adminGenerique.gerer' | translate }}</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li
                  class="nav-item common-nav-item"
                  *ngIf="
                    (autorisations?.includes('CONSULTATION_CONTRAT') ||
                    autorisations?.includes('GESTION_CONTRAT')) &&
                    (roles?.includes('REPRESENTANT_LEGAL') ||
                    roles?.includes('MANDATAIRE'))
                  "
                >
                  <button
                    class="nav-link"
                    type="button"
                    data-toggle="collapse"
                    data-target="#nav-collapse-submenu--2"
                    aria-controls="nav-collapse-submenu--2"
                    aria-expanded="false"
                    (click)="openMenu(2)"
                  >
                    {{ 'header.structuresContrats.title' | translate }}
                  </button>
                  <div
                    class="collapse nav-collapse"
                    id="nav-collapse-submenu--2"
                    data-parent="#menuPrincipal"
                    [ngClass]="{ show: idMenuOpen == 2 && showSubMenu }"
                    [style.left.px]="-55"
                  >
                    <div class="nav-collapse-inner">
                      <ul class="navbar-nav nav-lvl--2" (click)="onBlur()">
                        <li *ngIf="autorisations?.includes('CONSULTATION_CONTRAT')" class="nav-item common-nav-item">
                            <a class="nav-link" href="javascript:void(0);" (click)="navigate('/contrat')">{{ 'header.structuresContrats.visualiser' | translate }}</a>
                        </li>
                      </ul>
                    </div>
                    <hr *ngIf="autorisations?.includes('GESTION_CONTRAT')" class="mb-1 mt-1" aria-hidden="true" />
                    <div class="nav-collapse-inner">
                      <ul class="navbar-nav nav-lvl--2" (click)="onBlur()">
                        <li *ngIf="autorisations?.includes('GESTION_CONTRAT')" class="nav-item common-nav-item">
                            <a class="nav-link" href="javascript:void(0);" (click)="navigate('/contrat/gestion')">{{ 'header.structuresContrats.gerer' | translate }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li *ngIf="!isVisitor" class="nav-item common-nav-item">
                  <a
                    class="nav-link"
                    rel="noopener"
                    target="_blank"
                    [href]="AIDE_HEADER_URL"
                  >
                    <span class="d-block d-xl-none">{{'header.aide' | translate}}</span>
                    <svg
                      class="d-none d-xl-block svg-icon svg-question-circle"
                      style="margin-top:4px;"
                      data-html="true"
                      type="button"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <use xlink:href="../../../assets/svg-icons/icon-sprite.svg#question-circle"></use>
                    </svg>
                  </a>
                </li>
                <li hidden class="nav-item common-nav-item">
                  <button
                    class="nav-link"
                    type="button"
                    data-toggle="collapse"
                    data-target="#nav-collapse-submenu--4"
                    aria-controls="nav-collapse-submenu--4"
                    aria-expanded="false"
                    (click)="openMenu(3)"
                  >
                    Support
                  </button>
                  <div
                    class="collapse nav-collapse"
                    id="nav-collapse-submenu--4"
                    data-parent="#menuPrincipal"
                    [ngClass]="{ show: idMenuOpen == 3 }"
                  >
                    <div class="nav-collapse-inner">
                      <ul class="navbar-nav nav-lvl--2">
                        <li class="nav-item common-nav-item">
                          <a class="nav-link"
                            >Label menu with long text lorem ipsum</a
                          >
                        </li>
                        <li class="nav-item common-nav-item">
                          <a class="nav-link">Label menu</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </nav>

            <ul class="nav-right">
              <li
                hidden
                class="nav-right-item collapse-wrapper common-nav-item"
              >
                <button
                  type="button"
                  class="btn btn--icon-only btn-icon--header"
                  aria-label="Accessibilité"
                  data-toggle="collapse"
                  data-target="#collapseAccess"
                  aria-controls="collapseAccess"
                  aria-expanded="false"
                  (click)="openMenu(4)"
                >
                  <svg
                    class="svg-icon svg-access"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <use
                      xlink:href="assets/svg-icons/icon-sprite.svg#access"
                    ></use>
                  </svg>
                  <span class="title-responsive">Accessibilité</span>
                </button>
                <div
                  class="collapse nav-collapse nav-collapse--right"
                  id="collapseAccess"
                  [ngClass]="{ show: idMenuOpen == 4 }"
                >
                  <p class="o-widget-access__intro">Options d'accessibilité</p>

                  <div class="o-widget-access">
                    <div class="form-group form-group-custom-control">
                      <fieldset id="contrast-id">
                        <legend>Contrastes :</legend>

                        <div class="o-widget-access__option">
                          <input
                            id="default-c"
                            value="default-c"
                            name="contrast"
                            checked="checked"
                            type="radio"
                            class="sr-only"
                          />
                          <label
                            class="o-widget-access__label btn btn--ghost btn--primary btn-sm"
                            for="default-c"
                            ><span class="sr-only">Contrastes</span>
                            Standards</label
                          >
                        </div>
                        <div class="o-widget-access__option">
                          <input
                            id="high-c"
                            value="high-c"
                            name="contrast"
                            type="radio"
                            class="sr-only"
                          />
                          <label
                            class="o-widget-access__label btn btn--ghost btn--primary btn-sm"
                            for="high-c"
                            ><span class="sr-only">Contrastes</span>
                            Renforcés</label
                          >
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <!-- PROFIL BUTTON + POPIN -->
          <div class="collapse-wrapper common-nav-item">
            <button
              type="button"
              class="btn btn--icon-only btn-icon--header"
              aria-label="Menu utilisateur"
              data-toggle="collapse"
              data-target="#collapseUser"
              aria-controls="collapseUser"
              aria-expanded="false"
              (click)="openMenu(5)"
            >
              <svg
                class="svg-icon svg-user"
                aria-hidden="true"
                focusable="false"
              >
                <use
                  xlink:href="../../../assets/svg-icons/icon-sprite.svg#user"
                ></use>
              </svg>
              <span class="sr-only">Menu utilisateur</span>
            </button>
            <div
              class="collapse nav-collapse nav-collapse--right"
              id="collapseUser"
              [ngClass]="{ show: idMenuOpen == 5 && showSubMenu }"
            >
              <div class="m-user">
                <div class="m-user__icon">
                  <svg
                    class="svg-icon svg-user"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <use
                      xlink:href="../../../assets/svg-icons/icon-sprite.svg#user"
                    ></use>
                  </svg>
                </div>
                <p class="m-user__name">{{ utilisateur }}</p>
                <p class="m-user__info">{{ position }}</p>
                <ul class="navbar-nav">
                  <li class="m-user__name" *ngIf="getPermissions(permission.CL)">
                    <svg
                      class="svg-icon svg-angle-right"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <use
                        xlink:href="assets/svg-icons/icon-sprite.svg#angle-right"
                      ></use>
                    </svg>
                    <a class="ml-1" href="javascript:void(0);" (click)="navigate('/profile')">
                      {{ 'header.profile' | translate }}
                    </a>
                  </li>
                </ul>
                <confirm-window
                  (click)="configConfirmWindow()"
                  (windowResponseEvent)="handleConfirmationEvent($event)"
                  buttonText="{{ 'header.deconexion' | translate }}"
                ></confirm-window>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</header>
